// Helpers for the dynamic questionnaire (questions now come from the backend).
import {
  MapPin, Users, Baby, GraduationCap, Briefcase, Laptop, Rocket, Wallet, Home,
  Building2, Sun, ShieldCheck, HeartPulse, Receipt, TrainFront, Sparkles,
  PartyPopper, Plane, Gauge, Target, Compass, Trees, Landmark, Languages,
} from "lucide-react";

export const SCALE_LABELS = ["Not at all", "Slightly", "Moderately", "Very", "Essential"];

export const SCALE10_LABELS = { min: "Not important", max: "Extremely important" };

// Map a question category to a lucide icon for the wizard header.
export const CATEGORY_ICONS = {
  "Family situation": Users,
  "Kids and education": GraduationCap,
  "Budget and cost of living": Wallet,
  "Housing preferences": Home,
  "Career and job market": Briefcase,
  "Remote work lifestyle": Laptop,
  "Business and entrepreneurship": Rocket,
  "Safety and crime": ShieldCheck,
  "Healthcare": HeartPulse,
  "Climate and environment": Sun,
  "Transportation and commuting": TrainFront,
  "Social life and community": PartyPopper,
  "Immigration / relocation complexity": Plane,
  "Taxes and financial priorities": Receipt,
  "Lifestyle preferences": Sparkles,
  "Long-term goals": Target,
  "Risk tolerance": Gauge,
  "City size preference": Building2,
  "Culture and values": Landmark,
  "Recreation and outdoor lifestyle": Trees,
  Location: MapPin,
  Language: Languages,
  Baby,
  Compass,
};

// Server sends `format` as a string key; map it to a display formatter.
export const NUM_FORMATS = {
  currency_mo: (v) => `$${Number(v).toLocaleString()}/mo`,
  currency: (v) => `$${Number(v).toLocaleString()}`,
};
